import React from 'react';
import { motion } from 'framer-motion';
import MoneyUtils from '../../../utils/moneyUtils';
import Icon from '../../../components/AppIcon';


const HorizontalItemCard = ({ item, onClick }) => {
  const showOffer =
    typeof item?.price === 'number' &&
    typeof item?.offerPrice === 'number' &&
    item.offerPrice < item.price;

  const discount = showOffer
    ? Math.round(((item.price - (item?.offerPrice ?? 0)) / item.price) * 100)
    : null;

  const displayPrice = showOffer ? item.offerPrice : item.price;

  return (
    <motion.div
      onClick={onClick}
      layout
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.9 }}
      transition={{ type: 'spring', stiffness: 300, damping: 25 }}
      className="shrink-0 flex flex-col w-32 text-xs bg-white rounded-md shadow-md overflow-hidden cursor-pointer"
    >
      {/* Image */}
      <div className="relative w-full aspect-video bg-gray-100">
        {item?.imageUrl ? (
          <img
            src={item.imageUrl}
            alt={item?.name || 'Menu item'}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full bg-gray-50 flex items-center justify-center text-gray-300">
            <Icon 
              name={/(drink|beverage|juice|coffee|tea|shake|smoothie|water)/i.test(item?.category || item?.name) ? 'Coffee' : 'Utensils'} 
              size={20} 
              strokeWidth={1.5}
            />
          </div>
        )}

        {/* Discount badge */}
        {discount && (
          <div className="absolute top-1 left-1 bg-white/30 backdrop-blur-sm text-black text-[8px] p-1 rounded">
            <p>{discount}% OFF</p>
          </div>
        )}
      </div>

      {/* Name & Price */}
      <div className="p-1 text-xs">
        <h3 className="font-bold text-gray-800 truncate" title={item?.name}>
          {item?.name
            ? item.name.charAt(0).toUpperCase() + item.name.slice(1)
            : ''}
        </h3>
        <div className="flex items-baseline gap-1">
          <p className="font-semibold text-gray-900">
            {MoneyUtils.format(displayPrice ?? 0)}
          </p>
          {showOffer && (
            <p className="text-gray-400 line-through text-[10px]">
              {MoneyUtils.format(item.price)}
            </p>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default HorizontalItemCard;
